























import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { IJWT } from '@/lib/interfaces';

interface IRoute {
  name: string;
  visibleName: string;
}

@Component({
  computed: mapGetters(['isNavBarActive']),
})
export default class Navigation extends Vue {
  private routes: IRoute[] = [
    {
      name: 'users',
      visibleName: 'Сотрудники',
    },
    {
      name: 'projects',
      visibleName: 'Проекты',
    },
    {
      name: 'actual_issues',
      visibleName: 'Задачи',
    },
    {
      name: 'customers',
      visibleName: 'Справочник',
    },
    {
      name: 'my_logworks',
      visibleName: 'Мои списания',
    },
  ];

  get availableRoutes(): IRoute[] {
    return this.routes.reduce<IRoute[]>((prev, cur) => {
      const route = this.$router.resolve(cur.name).route;
      if (route.meta.requiredRoles) {
        const user: IJWT = this.$store.getters.getCurrentUser;
        for (const role of user.roles) {
          if (route.meta.requiredRoles.includes(role)) {
            prev.push(cur);
            break;
          }
        }
      } else {
        prev.push(cur);
      }
      return prev;
    }, []);
  }
}
